import { Typography } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import Link from 'antd/lib/typography/Link';
import SectionTitle, { sectionIconStyle } from './SectionTitle';

const MoreInformation = () => (
    <>
        <SectionTitle text="More Information" icon={<GlobalOutlined style={sectionIconStyle} />} />
        <Typography>
            For more information and assistance visit{' '}
            <Link
                target="_blank"
                href="https://taxation-customs.ec.europa.eu/customs/customs-security/import-control-system-2_en"
            >
                EU Import Control System 2 (ICS2)
            </Link>
        </Typography>
    </>
);

export default MoreInformation;
